import React from "react";
import { assets } from "../assets/assets_frontend/assets";

const Header = () => {
  return (
    <div className="bg-primary flex flex-col md:flex-row w-full px-6 rounded-lg md:px-10  flex-wrap">
      <div className=" md:w-1/2 flex flex-col justify-center items-start gap-4 py-10 m-auto md:py-[10vw] md:mb-[-30px]">
        <p>book appoinment</p>
        <div>
          <img src={assets.group_profiles} alt="alt" />
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora at
            quibusdam recusandae obcaecati tenetur iusto maxime dolorum odio vel
            ipsam!
          </p>
        </div>
        <a
          href="#speciality"
          className="bg-white flex gap-3 rounded-full px-2 py-3"
        >
          book appointment <img src={assets.arrow_icon} alt="d" />
        </a>
      </div>
      {/* ................................................................ */}
      <div className=" md:w-1/2 relative">
        <img
          className="w-full md:absolute h-auto bottom-0 rounded-lg "
          src={assets.header_img}
          alt="lsmd"
        />
      </div>
    </div>
  );
};

export default Header;
